import { api } from "@/api/client";

export const trackCall = (source) => {
  // Non-blocking analytics — never break the tel: link
  try {
    api.post("/track/call", {
      source,
      lang: localStorage.getItem("fom_lang") || "en",
      user_agent: navigator.userAgent.slice(0, 200),
    }).catch(() => {});
  } catch (e) {
    // no-op
  }
};
